import { DeviceAvailableMeasure } from '@weenat/client/dist/resources'
import { useIntl } from '@weenat/wintl'
import { IconProps } from './Icon'
import Icons from './Icons'
import MetricIcons from './icons/MetricIcons'
import TextTooltip from './tooltips/TextTooltip'

/**
 * list of metric that have the same pictogram as another metric
 * we exclude them from stacked icons to avoid displaying same pictogram twice
 */
const metricWithSamePictogram: Readonly<DeviceAvailableMeasure[]> = [
  'FXY',
  'DXY',
  'LW_D',
  'SSI_MIN',
  'SSI_MAX',
  'PPFD_MAX',
  'PPFD_MIN'
] as const

export const MetricBadge: FC<{ metric: DeviceAvailableMeasure; zIndex?: number }> = ({
  metric,
  zIndex = 1
}) => {
  const Icon: FC<IconProps> = MetricIcons[metric] ?? Icons.Placeholder
  const metricColor = (`metrics.${metric}.500` as const) || 'grayscale.black'

  return (
    <Box $borderRadius={'md'} $boxShadow='sm' $zIndex={zIndex} $ml={-8} $position='relative'>
      <Icon
        $color={'grayscale.white'}
        $size='md'
        $backgroundColor={metricColor}
        $borderColor={`metrics.${metric}.800`}
        $p='sm'
      />
    </Box>
  )
}

interface StackedMetricsProps {
  metrics: DeviceAvailableMeasure[]
  className?: string
}

const StackedMetrics: FC<StackedMetricsProps> = ({ className, metrics }) => {
  const { t } = useIntl()

  const visibleMeasures = metrics.filter((m) => m !== 'T_CAL' && m !== 'T_CAPA')

  return (
    <Flex className={className}>
      {visibleMeasures.map((metric, idx) => {
        if (metricWithSamePictogram.includes(metric)) return null
        const metricLabel = t(`metrics.${metric as 'T'}`, { capitalize: true })
        const zIndex = idx + 1
        return (
          <TextTooltip key={metric} content={metricLabel}>
            <MetricBadge metric={metric} zIndex={zIndex} />
          </TextTooltip>
        )
      })}
    </Flex>
  )
}

export default StackedMetrics
